// src/core/services/store/admin-reports-user-categories.module.js

import ApiService from "@/core/services/api.service";

export const FETCH_USER_CATEGORIES_REPORT = "fetchUserCategoriesReport";
export const FETCH_USER_CATEGORIES_STATS = "fetchUserCategoriesStats";

export const SET_USER_CATEGORIES_REPORT = "setUserCategoriesReport";
export const SET_USER_CATEGORIES_STATS = "setUserCategoriesStats";

const state = {
  list: [],
  stats: {
    total_profiles: 0,
    account_types: {
      real: { count: 0, percent: 0 },
      company: { count: 0, percent: 0 },
    },
    categories: [],
    destinations: [],
  },
  pagination: {
    current_page: 1,
    last_page: 1,
    total: 0,
    per_page: 10,
  },
};

const getters = {
  userCategoriesList: (state) => state.list,
  userCategoriesStats: (state) => state.stats,
  userCategoriesPagination: (state) => state.pagination,
};

const actions = {
  [FETCH_USER_CATEGORIES_REPORT](context, payload = {}) {
    let params = {
      page: context.state.pagination.current_page,
    };

    if (payload.page) {
      params.page = payload.page;
    }

    return new Promise((resolve, reject) => {
      ApiService.query("admin/admin-reports/user-profile", { params })
        .then(({ data }) => {
          context.commit(SET_USER_CATEGORIES_REPORT, {
            list: data.data || [],
            pagination: {
              current_page: data.current_page || 1,
              last_page: data.last_page || 1,
              total: data.total || 0,
              per_page: data.per_page || 10,
            },
          });
          resolve(data);
        })
        .catch(({ response }) => reject(response));
    });
  },

  [FETCH_USER_CATEGORIES_STATS](context) {
    return ApiService.query("admin/admin-reports/user-profile-stats").then(
      ({ data }) => {
        context.commit(SET_USER_CATEGORIES_STATS, data);
      }
    );
  },
};

const mutations = {
  [SET_USER_CATEGORIES_REPORT](state, payload) {
    state.list = payload.list;
    state.pagination = payload.pagination;
  },
  [SET_USER_CATEGORIES_STATS](state, payload) {
    state.stats = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
